import {
    MODERATION_FEED_ITEM_FULLTEXT_RESPONSE,
    MODERATION_FEED_ITEM_RESPONSE,
    UNAUTHENTICATED
} from "../../actions/action-types"

export default (state = {}, action) => {
    const { type, data, receivedAt } = action
    switch (type) {
        case MODERATION_FEED_ITEM_RESPONSE:
        case MODERATION_FEED_ITEM_FULLTEXT_RESPONSE:
            const { id } = data
            if (type === MODERATION_FEED_ITEM_RESPONSE && !data.fulltext) {
                return state
            }
            return {
                ...state,
                [id]: {
                    ...data,
                    lastUpdatedAt: receivedAt
                }
            }
        case UNAUTHENTICATED:
            return {}
        default:
            return state
    }
}
